import axios from 'axios'
import utils from '@/plugins/utils'

const SLOT_API = '/slots/'
const CLASS_API = '/classes/'
const STUDENT_API = '/students/'
const ATTENDANCE_API = '/attendances/'
const LOG_API = '/Logs/'
const MAJOR_API = '/Majors/'
const GENERATION_API = '/Generations/'
const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'
const COURSE_API = '/courses/'
const COURSE_MARK_CONFIG_API = '/course-mark-configs/'
const COURSE_MARK_API = '/course-marks/'
const COURSE_MARK_ELEMENT_API = '/course-mark-elements/'
const MARK_ELEMENT_API = '/mark-elements/'
const FINAL_MARK_SHEET_API = '/final-mark-sheets/'
const RETEST_MARK_SHEET_API = '/retest-mark-sheets/'
const RETEST_MARK_API = '/retest-marks/'
const LEARNING_RESULT_API = '/learning-results/'
const LESSON_API = '/lessons/'
const STAFF_API = '/staff/'
const TEACHER_API = '/teachers/'
const USER_API = '/users/'
const BILL_API = '/bills/'
const PRODUCT_API = '/products/'
const AUTH_API = '/auth/local'
const MARK_API = '/marks/'
const LEAD_API = '/leads/'
const TRANSCRIPT_API = '/transcripts/'
const FACILITY_API = '/facilities/'
const LIBRARY_API = '/facilities/'
const ROOM_API = '/rooms/'
const SHOWCASE_API = '/showcases/'
const OVERALL_MARKSHEET_API = '/overall-mark-sheets/'
const MARKSHEET_ROW_API = '/overall-mark-sheet-rows/'
const SEMESTER_CONFIG_API = '/semester-configs/'
const SEMESTER_COURSE_CONFIG_API = '/semester-course-configs/'
const STUDENT_GROUP_API = '/student-groups'
const OTP_API = '/otp/'
const ACCOUNT_SHEET_API = '/account-sheets/'
const ACCOUNTANT_API = '/accountants/'
const SUPER_ADMIN_API = '/super-admins/'
const EDUCATION_MANAGER_API = '/education-managers/'
const ACCOUNT_SHEET_ROW_API = '/account-sheet-rows/'
const ACCOUNT_SHEET_ROW_GROUP_API = '/account-sheet-row-groups/'
const RESERVATION_API = '/reservations/'
const ABORTION_API = '/abortions/'
const GRADUATION_API = '/graduations/'

const APIHelper = api => ({
  search: (params, option) => axios.get(api, { params: utils.filterObject(params) }, option),
  count: (params, option) =>
    axios.get(api + 'count', { params: utils.filterObject(params) }, option),
  fetch: (params, option) => axios.get(api, { params: utils.filterObject(params) }, option),
  fetchOne: (id, option) => axios.get(api + id, option),
  create: (params, options) => axios.post(api, utils.filterObject(params), options),
  update: (id, params, option) => axios.put(api + id, utils.filterObject(params), option),
  remove: (id, option) => axios.delete(api + id, option),
  removeMany: option => axios.delete(api + 'many', option),
  createMany: (data, option) => axios.post(api + 'many', data, option)
})
export const APIRespository = APIHelper
export const Otp = {
  create: ({ user }, options) => axios.post(OTP_API + '', { user }, options),
  validate: ({ otp, user }, options) => axios.post(OTP_API + 'validate', { otp, user }, options),
  resend: ({ user }) => axios.get(OTP_API + 'resend', { params: { user } })
}
export const Auth = {
  ...APIHelper(AUTH_API),
  forgotPassword: email => axios.post('/auth/forgot-password', { email }),
  resetPassword: (code, password, passwordConfirmation) =>
    axios.post('/auth/reset-password', {
      code,
      password,
      passwordConfirmation
    })
}

const Class = APIHelper(CLASS_API)
Class.updateMarks = (id, params, options) => {
  return axios.post(CLASS_API + [id, 'update-marks'].join('/'), utils.filterObject(params), options)
}
Class.clearMarkData = (id, options) => {
  return axios.get(CLASS_API + [id, 'clear-data'].join('/'), options)
}
Class.removeStudentData = (id, options) => {
  return axios.get(CLASS_API + [id, 'remove-student-data'].join('/'), options)
}
Class.recalculateAll = (id, options) => {
  return axios.get(CLASS_API + [id, 'recalculate-all'].join('/'), options)
}
const Student = APIHelper(STUDENT_API)
const Attendance = APIHelper(ATTENDANCE_API)
const Slot = APIHelper(SLOT_API)
const Log = APIHelper(LOG_API)

const Major = APIHelper(MAJOR_API)
const Generation = APIHelper(GENERATION_API)
const Course = APIHelper(COURSE_API)
const CourseMarkConfig = APIHelper(COURSE_MARK_CONFIG_API)
const CourseMark = APIHelper(COURSE_MARK_API)
CourseMark.updateMany = data => axios.put(COURSE_MARK_API + ['update-many'].join('/'), data)

const CourseMarkElement = APIHelper(COURSE_MARK_ELEMENT_API)
CourseMarkElement.updateMany = data =>
  axios.put(COURSE_MARK_ELEMENT_API + ['update-many'].join('/'), data)

const FinalMarkSheet = APIHelper(FINAL_MARK_SHEET_API)
FinalMarkSheet.removeMarkElements = (id, options) => {
  return axios.get(FINAL_MARK_SHEET_API + [id, 'delete-mark-elements'].join('/'), options)
}
const RetestMarkSheet = APIHelper(RETEST_MARK_SHEET_API)
RetestMarkSheet.mapCourseMarkConfig = (id, options) => {
  return axios.get(RETEST_MARK_SHEET_API + [id, 'map-config'].join('/'), options)
}
const RetestMark = APIHelper(RETEST_MARK_API)
RetestMark.updateMany = data => axios.put(RETEST_MARK_API + ['update-many'].join('/'), data)

const MarkElement = APIHelper(MARK_ELEMENT_API)
MarkElement.updateMany = data => axios.put(MARK_ELEMENT_API + ['update-many'].join('/'), data)

const LearningResult = APIHelper(LEARNING_RESULT_API)
LearningResult.upsertMany = data => {
  return axios.post(LEARNING_RESULT_API + ['upsert-many'].join('/'), utils.filterObject(data))
}
const Lesson = APIHelper(LESSON_API)
const Staff = APIHelper(STAFF_API)
Staff.swap = (id, params, option) =>
  axios.put(STAFF_API + ['swap', id].join('/'), utils.filterObject(params), option)

const Teacher = APIHelper(TEACHER_API)
const User = APIHelper(USER_API)
const Bill = APIHelper(BILL_API)
const Product = APIHelper(PRODUCT_API)
const Mark = APIHelper(MARK_API)
Mark.reCalculateFinalMark = options => {
  return axios.get(MARK_API + ['calculate-final-mark'].join('/'), options)
}
const Facility = APIHelper(FACILITY_API)
const Lead = APIHelper(LEAD_API)
const Book = APIHelper(LIBRARY_API)
const Transcript = APIHelper(TRANSCRIPT_API)
const Room = APIHelper(ROOM_API)
const Showcase = APIHelper(SHOWCASE_API)
const SemesterCourseConfig = APIHelper(SEMESTER_COURSE_CONFIG_API)
const SemesterConfig = APIHelper(SEMESTER_CONFIG_API)
const OverallMarkSheet = APIHelper(OVERALL_MARKSHEET_API)
const MarkSheetRow = APIHelper(MARKSHEET_ROW_API)
const AccountSheetRowGroup = APIHelper(ACCOUNT_SHEET_ROW_GROUP_API)
const AccountSheetRow = APIHelper(ACCOUNT_SHEET_ROW_API)
const AccountSheet = APIHelper(ACCOUNT_SHEET_API)
const Accountant = APIHelper(ACCOUNTANT_API)
const SuperAdmin = APIHelper(SUPER_ADMIN_API)
const Reservation = APIHelper(RESERVATION_API)
const Abortion = APIHelper(ABORTION_API)
const Graduation = APIHelper(GRADUATION_API)
SuperAdmin.swap = (id, params, option) =>
  axios.put(SUPER_ADMIN_API + ['swap', id].join('/'), utils.filterObject(params), option)

Accountant.swap = (id, params, option) =>
  axios.put(ACCOUNTANT_API + ['swap', id].join('/'), utils.filterObject(params), option)

const EducationManager = APIHelper(EDUCATION_MANAGER_API)
EducationManager.swap = (id, params, option) =>
  axios.put(EDUCATION_MANAGER_API + ['swap', id].join('/'), utils.filterObject(params), option)

AccountSheet.content = (id, option) =>
  axios.get(ACCOUNT_SHEET_API + ['content', id].join('/'), option)
AccountSheet.publish = (id, option) =>
  axios.get(ACCOUNT_SHEET_API + ['publish', id].join('/'), option)
AccountSheet.cancel = (id, data) => axios.post(ACCOUNT_SHEET_API + ['cancel', id].join('/'), data)
AccountSheet.recalculate = (id, option) =>
  axios.get(ACCOUNT_SHEET_API + ['recalculate', id].join('/'), option)

OverallMarkSheet.fetchContent = (id, option) =>
  axios.get(OVERALL_MARKSHEET_API + [id, 'content'].join('/'), option)

const StudentGroup = APIHelper(STUDENT_GROUP_API)
const Upload = {
  upload: formData =>
    axios.post(UPLOAD_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),
  destroy: id => axios.delete(DESTROY_API + id)
}

export {
  Graduation,
  Class,
  Student,
  Attendance,
  Slot,
  Log,
  Major,
  Generation,
  Course,
  CourseMark,
  LearningResult,
  Lesson,
  Staff,
  Teacher,
  User,
  Bill,
  Product,
  Mark,
  Facility,
  Lead,
  Book,
  Transcript,
  Room,
  Showcase,
  Upload,
  CourseMarkElement,
  MarkElement,
  FinalMarkSheet,
  CourseMarkConfig,
  RetestMarkSheet,
  RetestMark,
  SemesterCourseConfig,
  SemesterConfig,
  OverallMarkSheet,
  StudentGroup,
  MarkSheetRow,
  AccountSheet,
  Accountant,
  SuperAdmin,
  EducationManager,
  AccountSheetRow,
  AccountSheetRowGroup,
  Reservation,
  Abortion
}

export default {
  Auth,
  Graduation,
  Class,
  Attendance,
  Slot,
  Log,
  Student,
  Generation,
  Major,
  User,
  Mark,
  Facility,
  Lead,
  Staff,
  Transcript,
  Room,
  Book,
  Showcase,
  CourseMarkElement,
  MarkElement,
  FinalMarkSheet,
  CourseMarkConfig,
  RetestMarkSheet,
  RetestMark,
  SemesterCourseConfig,
  SemesterConfig,
  OverallMarkSheet,
  MarkSheetRow,
  StudentGroup,
  AccountSheet,
  Accountant,
  SuperAdmin,
  EducationManager,
  AccountSheetRow,
  AccountSheetRowGroup,
  Reservation,
  Abortion
}
